// Single source of Opportunity stage presentation for board cards and the Manage header badge.
import { Opportunity, OpportunityStage, OpportunityStageSystemName } from '@jms/model';
import type { StatusTag } from '../../shared/define.status.tag';
import { statusToneStyle, StatusTone } from '../../shared/status.tag.tones';

export const opportunityStageTag: StatusTag<Opportunity> = value => {

  const stage = value as OpportunityStage | null | undefined;
  if (!stage) return null;
  let tone: StatusTone = 'brand';
  if (stage.systemName === OpportunityStageSystemName.ClosedWon) tone = 'success';
  if (stage.systemName === OpportunityStageSystemName.ClosedLost) tone = 'error';
  return { label: stage.name ?? stage.systemName, ...statusToneStyle(tone) };
};
